import { styled } from 'baseui'

export const HopTimusButtonWrapper = styled('button', ({ $theme }) => ({
  position: 'fixed',
  right: '1.25rem',
  bottom: '5.75rem',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  border: 'none',
  borderRadius: '9999px',
  padding: '0.5rem 1rem 0.5rem 0.5rem',
  backgroundColor: $theme.colors.primary,
  color: $theme.colors.white,
  cursor: 'pointer',
  boxShadow: $theme.lighting.shadow400,
  ...$theme.typography.LabelMedium,

  ':disabled': {
    cursor: 'default',
    opacity: 0.7,
  },
}))

export const HopTimusAvatar = styled('img', ({ $theme }) => ({
  width: '2rem',
  height: '2rem',
  borderRadius: '50%',
  backgroundColor: $theme.colors.white,
  objectFit: 'cover',
  flexShrink: 0,
}))
